export default __webpack_public_path__ + "static/media/correct.b762913c.png";